<template>
	<base-modal
		ref="$modal"
		class="project-finance-expand-dialog"
		:title="$t('finances')"
		fullscreen-on-mobile
		stack-header-right-on-mobile
	>
		<template #header-right>
			<project-finance-summary
				:project="project"
				:stacked="isMobile"
			/>
		</template>

			<div class="finance-expand">
				<project-finance-section
					:project="project"
					:project-id="project?.Id ?? 0"
					:finance-access="project?.FinanceAccess"
					:expanded="true"
					@changed="emit('changed')"
				/>
			</div>
	</base-modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import ProjectFinanceSection from "@/components/main/project-block-page/finance/ProjectFinanceSection.vue";
import ProjectFinanceSummary from "@/components/main/project-block-page/finance/ProjectFinanceSummary.vue";
import { projectPageStore } from "@/store/project-page";
import { useBreakpoints } from "@/composables/useBreakpoints";

const projectStore = projectPageStore()

const project = computed(() => projectStore.openedProject)
const { isMobile } = useBreakpoints()

const emit = defineEmits<{
	(e: 'changed'): void,
}>()

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.finance-expand {
	height: 100%;
	min-height: 0;
	padding: 4px 12px 12px 12px;
	overflow: hidden;
	box-sizing: border-box;
}
</style>

<style lang="scss">
.q-dialog.base-modal-dialog.project-finance-expand-dialog {
	z-index: 6000;
}
</style>
